import isFunction from 'lodash/isFunction';
import firebase from '@/config/firebase';
import {
  state,
  getters,
  setUser,
  updateUser as stateUpdateUser,
} from '@/config/store';

const db = firebase.firestore();

export const onUserReady = (callback) => {
  callback = isFunction(callback) ? callback : () => {};
  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      db.collection('users')
        .doc(user.uid)
        .get()
        .then((doc) => {
          setUser(doc.data());
          callback();
        });
    } else {
      setUser(null);
      callback();
    }
  });
};

export const signup = ({ email, password, plan = 'free' }) => firebase.auth()
  .createUserWithEmailAndPassword(email, password)
  .then((res) => db.collection('users')
    .doc(res.user.uid)
    .set({
      uid: res.user.uid,
      email,
      plan,
      createdAt: Date.now(),
      paymentAt: plan === 'free' ? Date.now() : false,
    }));

export const login = (email, password) => firebase.auth().signInWithEmailAndPassword(email, password);
export const logout = () => firebase.auth().signOut();

export const updateUser = ({ plan = 'free', paymentAt = false }) => {
  if (!getters.isLoggedin) {
    return Promise.reject(new Error('NOT_LOGGED_IN'));
  }

  return db.collection('users')
    .doc(state.user.uid)
    .update({ plan, paymentAt })
    .then(() => stateUpdateUser({ plan, paymentAt }));
};
